<router-outlet></router-outlet>
<app-cookie-banner></app-cookie-banner>
<app-ml-translation-widget></app-ml-translation-widget>